import { render, staticRenderFns } from "./Invoice.vue?vue&type=template&id=2f26ed50&scoped=true"
import script from "./Invoice.vue?vue&type=script&lang=js"
export * from "./Invoice.vue?vue&type=script&lang=js"
import style0 from "./Invoice.vue?vue&type=style&index=0&id=2f26ed50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f26ed50",
  null
  
)

export default component.exports